export default __webpack_public_path__ + "static/media/icon_resurssit_aloittamatta.b2269fc0.svg";